import React,{useState,useEffect} from 'react'
import { Link  } from 'react-router-dom';
import { IoIosSearch } from "react-icons/io";
import DatePicker from "react-datepicker";
import { FaRegCalendarAlt } from "react-icons/fa";
import axios from "axios";
import config from "../config";
import Pagination  from "../common/Pagination";

function WithDrawlReports() { 
   const [itemsPerPage, setItemsPerPage] = useState(10); 
    const [searchTerm, setSearchTerm] = useState(''); 
    const [reports, setReportsData] = useState([]);
    
  
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [formData, setFormData] = useState({
      startDate: null,
      endDate: null,
      search: '',
      status: ''
    });
    
    const limit = 10; // Number of items per page
    
    // Only call API on initial load and page changes
    useEffect(() => {
      getWithDrawlReports();
    }, [currentPage]); // Only depend on currentPage

    const getWithDrawlReports = () => {
      // Format dates to YYYY-MM-DD format before sending to API
      const formatDate = (date) => {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      const payload = {
        page: currentPage,
        limit: limit,
        search: formData.search,
        startDate: formatDate(formData.startDate),
        endDate: formatDate(formData.endDate),
        status: formData.status
      };

      axios.post(`${config.backendUrl}/admin/withdrawals`, payload, {
        headers: {
          'token': localStorage.getItem('token'),
          'Content-Type': 'application/json',
        }
      })
      .then(response => {
        setReportsData(response.data.data);
        setTotalPages(Math.ceil(response.data.total_count / limit));
      })
      .catch(error => {
        console.error('Error:', error);
      });
    };
  
    const handlePageChange = (newPage) => {
      setCurrentPage(newPage);
    };
    
    const handleSearchChange = (event) => {
      setFormData({
        ...formData,
        search: event.target.value
      });
      // Don't reset page or call API here
    };
    
    const handleStatusChange = (event) => {
      setFormData({
        ...formData,
        status: event.target.value
      });
      // Don't reset page or call API here
    };
   
    function handleChange(date, fieldName) {
      setFormData(prevState => {
        const newState = {
          ...prevState,
          [fieldName]: date
        };
        
        // If start date is changed and it's after the current end date, clear end date
        if (fieldName === 'startDate' && prevState.endDate && date > prevState.endDate) {
          newState.endDate = null;
        }
        
        return newState;
      });
      // Don't call API here
    }

    const handleReset = () => {
      const clearedFilters = {
        startDate: null,
        endDate: null,
        status: "",
        search: ""
      };

      setFormData(clearedFilters);
      setCurrentPage(1);
      
      // Call API with cleared filters directly
      const payload = {
        page: 1,
        limit: limit,
        search: "",
        startDate: null,
        endDate: null,
        status: ""
      };

      axios.post(`${config.backendUrl}/admin/withdrawals`, payload, {
        headers: {
          'token': localStorage.getItem('token'),
          'Content-Type': 'application/json',
        }
      })
      .then(response => {
        setReportsData(response.data.data);
        setTotalPages(Math.ceil(response.data.total_count / limit));
      })
      .catch(error => {
        console.error('Error:', error);
      });
    };

    const handleApplyFilters = () => {
      console.log("Applying filters with data:", formData);
      setCurrentPage(1); // Reset to first page when applying filters
      
      // Call API only when Filter button is clicked
      setTimeout(() => {
        getWithDrawlReports();
      }, 0);
    };

    return (
        <> 
        <div className='flex justify-between items-center pt-[70px]'> 
          <div> 
            <h2> Withdrawal Report</h2>
            <div className='breadcrumbs'> <Link to="/admin/dashboard">Home</Link>{">"} Withdrawal Report </div>
          </div>
            <div className='flex gap-2 items-center'> 
            <div>
            </div> 
            <div className='flex gap-2 mob-wrap mob-alignfilters'> 
            </div>
        <div>
            
          </div> 
        
        </div>
    </div>
        
        
        <div  className='whitebox'>
            
    <form>
      <div className="flex justify-between mb-4"> 
        <h4 className="font-semibold">Statistics</h4>

        <div className="flex gap-4">  
             {/* Search Input */}
          <div className="flex items-center  rounded px-2 py-1">
            <input
              type="text"
              placeholder="Search"
              value={formData.search}
              name="search"
              onChange={handleSearchChange}
              className="outline-none"
            />
          </div>

          {/* Date Filters */}
          <div className="date-filters flex gap-2">
            <div className="flex items-center border rounded px-2 py-1">
              <DatePicker 
                selected={formData.startDate} 
                onChange={(date) => handleChange(date, 'startDate')}
                name="startDate" 
                placeholderText="From date"
                className="outline-none"
                maxDate={formData.endDate || new Date()}
                selectsStart
                startDate={formData.startDate}
                endDate={formData.endDate}
                dateFormat="dd/MM/yyyy"
              /> 
              <FaRegCalendarAlt className="ml-2 text-gray-500" />
            </div>

            <div className="flex items-center border rounded px-2 py-1">
              <DatePicker 
                selected={formData.endDate} 
                onChange={(date) => handleChange(date, 'endDate')}
                name="endDate" 
                placeholderText="To date"
                className="outline-none"
                minDate={formData.startDate}
                maxDate={new Date()}
                selectsEnd
                startDate={formData.startDate}
                endDate={formData.endDate}
                dateFormat="dd/MM/yyyy"
              />
              <FaRegCalendarAlt className="ml-2 text-gray-500" />
            </div>
          </div>

          {/* Status Dropdown */}
          <select 
            value={formData.status} 
            onChange={handleStatusChange}
            className="sort-dropdown w-40 border rounded px-2 py-1"
          >
            <option value="">All Status</option>
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
            <option value="failed">Failed</option>
            <option value="processing">Processing</option>
          </select>
         
         
          {/* Buttons */}
          <div className="flex items-center gap-2">
            <button 
              type="button"
              onClick={handleApplyFilters}
              className="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-500 transition"
            >
              Filter
            </button>

            <button 
              type="button"
              onClick={handleReset}
              className="px-4 py-2 rounded bg-gray-800 text-white hover:bg-gray-700 transition"
            >
              Reset
            </button>
          </div>

        </div>
      </div>
    </form>


        <div>
          <table className='tablegrid table-auto w-full border-collapse border' width={"100%"}>
            <thead>
              <tr className='bg-gray-100 text-left'>
                <th className="px-4 py-4 font-medium" style={{width: "60px"}}>S.No</th>
                <th className="px-4 py-4 font-medium" style={{width: "150px"}}>Name</th>
                <th   className="px-4 py-4 font-medium" style={{width: "120px"}}>Phone Number</th>
                <th className="px-4 py-4 font-medium" style={{width: "100px"}}>PaymentMode</th>
                <th className="px-4 py-4 font-medium" style={{width: "120px"}}>Redeemed Points</th>
                <th className="px-4 py-4 font-medium" style={{width: "130px"}}>Withdrawl Amount</th>
                <th className="px-4 py-4 font-medium"  style={{width: "100px"}}>Date</th>
                <th className="px-4 py-4 font-medium" style={{width: "120px"}}>Payment Status</th>
                <th className="px-4 py-4 font-medium" style={{width: "150px"}}>Transaction ID</th>
              </tr>
            </thead>
            <tbody>
              {reports.length === 0 ? (
                <tr>
                  <td colSpan="9" align="center">No records available</td>
                </tr>
              ) : (
                reports.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1 + (currentPage - 1) * limit}</td>
                    <td className="">{item.name || '-'}</td>
                    <td>{item.phone_number || '-'}</td>
                    <td>{item.payment_mode || '-'}</td>
                    <td>{item.redeemed_points || 0}</td>
                    <td>{item.withdrawal_amount || 0}</td>
                    <td>{item.date || '-'}</td>
                    <td>{item.payment_status || 'Pending'}</td>
                    <td>{item.transaction_id || '-'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <div className="flex justify-between">
              <div> </div>
              <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                 />

            </div>
          </div>

        </div>
        
        </>
      )
    }

export default WithDrawlReports
